import { render } from "./VabeneProductList.vue?vue&type=template&id=446a4fd2&ts=true"
import script from "./VabeneProductList.vue?vue&type=script&lang=ts"
export * from "./VabeneProductList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__